<template>
  <b-container fluid
               class="disclosure-template-detail-container">
    <!-- Spinner -->
    <loading :active="loading"
             :is-full-page="false"
             :z-index="1000"/>
    <!-- /Spinner -->

    <!-- Form and Table of Contents -->
    <div>
      <disclosure-template-form ref="template-from"
                                :template="template"/>
    </div>
    <!-- /Form and Table of Contents -->

    <!-- Buttons -->
    <div class="btn-container">
      <div class="btn-wrap">
        <esg-base-button @click="close"
                         variant="secondary">닫기
        </esg-base-button>
        <esg-base-button @click="update"
                         variant="primary">업데이트
        </esg-base-button>
      </div>
    </div>
    <!-- /Buttons -->
  </b-container>
</template>

<script>
import EsgBaseButton from "@/components/esg/base/EsgBaseButton.vue";
import DisclosureTemplateForm from "@/components/esg/6. ESG 공시보고/6.1. 보고서 항목 관리/DisclosureTemplateForm.vue";

export default {
  components: { DisclosureTemplateForm, EsgBaseButton },
  props: {
    id: {
      type: [String, Number],
      required: true,
    }
  },
  created() {
    this.load()
  },
  data() {
    return {
      loading: false,
      template: {
        id: null,
        title: '',
        description: '',
        tableOfContents: [],
        deletedItems: []
      },
    }
  },
  methods: {
    async load() {
      try {
        this.loading = true;

        let response = await axios.get(`esg/disclosure/disclosure-templates/${this.id}`, {
          headers: { Authorization: accessToken() }
        });

        if (!response.data) return;

        response.data.deletedItems = [];
        this.template = response.data;
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
      }
    },
    async update() {
      // Validate the disclosure template form
      if (!await this.$refs['template-from'].validateForm()) {
        return;
      }

      // Preprocess the table of contents
      this.preprocess(this.template.tableOfContents);

      try {
        this.loading = true;

        await axios.patch(`esg/disclosure/disclosure-templates/${this.id}`, this.template, {
          headers: { Authorization: accessToken() }
        });

        if (this.template.deletedItems.length > 0) {
          await axios.delete('esg/disclosure/template-items', {
            headers: { Authorization: accessToken() },
            params: { disclosureTemplateItemIds: this.template.deletedItems }
          });
          this.deletedItems = [];
        }

        this.loading = false;

        this.showMessageInToast(`목차가 업데이트되었습니다.`);
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
      }
    },
    preprocess(root) {
      if (typeof root === "object" && root.children) {
        root = root.children;
      }

      root.forEach((child, index) => {
        // Remove parent field to remove circular reference (if not, causes an error when converting to JSON)
        delete child.parent;

        // Remove UUID (if not, causes an error when converting to JSON)
        if (child.created) {
          delete child.id;
        }

        // Set order among its siblings
        child.order = index;
        this.preprocess(child);
      });
    },
    close() {
      this.pushRoute('/esg/disclosure-templates');
    },
  },
}
</script>

<style scoped>
.disclosure-template-detail-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 2rem;
}
</style>
